"use client"

import Link from 'next/link'
import { useRouter } from 'next/navigation'
import { Button } from '@/components/ui/button'
import { ButtonHeartbeatEffect } from '@/components/shadcn-studio/button/button-46'
import { useMe } from '@/hooks/use-me'
import React from 'react'
import { OnboardClientDialog } from '@/components/dialogs/OnboardClientDialog'
import { ClientProfileDialog } from '@/components/dialogs/ClientProfileDialog'
import ThemeToggle from '@/components/ThemeToggle'

export function Navbar() {
  const router = useRouter()
  const { data: me, isLoading } = useMe()
  const isClient = !!me && me.user_type === 'client' && !me.is_staff && !me.is_superuser
  const isInternal = !!me && !isClient
  const [onboardOpen, setOnboardOpen] = React.useState(false)
  const [profileOpen, setProfileOpen] = React.useState(false)
  const userPresent = !!me

  const handleSignOut = () => {
    router.push('/sign-out')
  }

  return (
    <header className="sticky top-0 z-30 w-full border-b border-[#E5E7EB] bg-white lg:bg-[#0F172A]">
      <div className="flex h-[58px] items-center justify-between bg-white px-5 lg:ml-[228px] lg:px-8">
        <div className="flex min-w-0 items-center gap-3">
          <Link href="/" className="truncate text-[15px] font-extrabold leading-5 text-[#111827]">
            Tiberius AI
          </Link>
          {isInternal ? (
            <div className="hidden h-6 w-px bg-[#E5E7EB] md:block" />
          ) : null}
          {isInternal ? (
            <div className="hidden text-[13px] font-bold leading-4 text-[#64748B] md:block">
              Workspace actions
            </div>
          ) : null}
        </div>
        {isLoading && (
          <div className="h-9 w-56 animate-pulse rounded-md bg-[#F1F5F9]" />
        )}
        {!isLoading && (
          <div className="flex items-center gap-2">
            {isInternal && (
              <ButtonHeartbeatEffect
                size="sm"
                label="Onboard Client"
                onClick={() => setOnboardOpen(true)}
                variant="default"
                className="h-10 rounded-md bg-[#2563EB] px-4 text-sm font-extrabold text-white shadow-none hover:bg-[#1D4ED8]"
              />
            )}
            {!userPresent && (
              <Link href="/login">
                <Button className="h-10 rounded-md bg-[#2563EB] px-4 text-sm font-extrabold text-white shadow-none hover:bg-[#1D4ED8]">Sign in</Button>
              </Link>
            )}
            {userPresent && (
              <>
                <ThemeToggle />
                {isInternal && (
                  <Link href="/profile">
                    <Button variant="outline" className="h-10 rounded-md border-[#D1D5DB] bg-white px-4 text-sm font-extrabold text-[#111827] shadow-none hover:bg-[#F8FAFC]">Profile</Button>
                  </Link>
                )}
                {isClient && (
                  <Button variant="outline" className="h-10 rounded-md border-[#D1D5DB] bg-white px-4 text-sm font-extrabold text-[#111827] shadow-none hover:bg-[#F8FAFC]" onClick={() => setProfileOpen(true)}>Profile</Button>
                )}
                <Button variant="outline" className="h-10 rounded-md border-[#D1D5DB] bg-white px-4 text-sm font-extrabold text-[#111827] shadow-none hover:bg-[#F8FAFC]" onClick={handleSignOut}>Sign out</Button>
              </>
            )}
          </div>
        )}
      </div>
      {isInternal && <OnboardClientDialog open={onboardOpen} onOpenChangeAction={setOnboardOpen} />}
      {isClient && me && <ClientProfileDialog open={profileOpen} onOpenChange={setProfileOpen} me={me} />}
    </header>
  )
}
